'use client';

import { useEffect, useState, type ComponentType } from 'react';
import { useLoadOnVisible } from '@/components/pages/use-load-on-visible';
import { ProcessStepsCarouselMobileServer } from './server';
import type { ProcessStepsProps } from '../type';

export default function LazyProcessStepsCarouselMobileClient(props: ProcessStepsProps) {
  const { ref, shouldLoad } = useLoadOnVisible<HTMLDivElement>();
  const [Client, setClient] = useState<ComponentType<ProcessStepsProps> | null>(null);

  useEffect(() => {
    if (!shouldLoad || Client) return;
    import('./client').then((module) => setClient(() => module.default));
  }, [Client, shouldLoad]);

  return (
    <div ref={ref}>
      {Client ? <Client {...props} /> : <ProcessStepsCarouselMobileServer {...props} />}
    </div>
  );
}
